import CouponModel from '../../../models/secure/CouponModel';

const checkEligibilityAndGetPriceAfterCouponPromo = async (context, payload) => {
    let couponModel = new CouponModel();
    return couponModel.checkEligibilityAndGetPriceAfterCouponPromo(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        } else {
            context.commit('CLEAR_PROMO_CODE'); //clears PromoCode from State if a new one is attempted but fails
            context.commit('CLEAR_COUPON_ID'); //clears couponID from State if a new one is attempted but fails
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

const checkEligibility = async (context, payload) => {
    context.commit('CLEAR_PROMO_CODE'); //clears PromoCode from State before trying to validate eligibility for offer page
    context.commit('CLEAR_COUPON_ID'); //clears couponID from State before trying to validate eligibility for offer page
    let couponModel = new CouponModel();
    return couponModel.checkEligibility(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        } else {
            context.commit('CLEAR_PROMO_CODE'); //clears PromoCode from State if a new one is attempted but fails
            context.commit('CLEAR_COUPON_ID'); //clears couponID from State if a new one is attempted but fails
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

const checkValidity = async (context, payload) => {
    let couponModel = new CouponModel();
    return couponModel.checkValidity(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        } else {
            context.commit('CLEAR_PROMO_CODE'); //clears PromoCode from State if a new one is attempted but fails
            context.commit('CLEAR_COUPON_ID'); //clears couponID from State if a new one is attempted but fails
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

const getNewPrice = async (context, payload) => {
    let couponModel = new CouponModel();
    return couponModel.getNewPrice(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        } else {
            context.commit('CLEAR_PROMO_CODE'); //clears PromoCode from State if a new one is attempted but fails
            context.commit('CLEAR_COUPON_ID'); //clears couponID from State if a new one is attempted but fails
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

const getCouponId = async (context, payload) => {
    let couponModel = new CouponModel();
    return couponModel.getCouponId(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

const savePromoCode = ({ commit }, promoCode) => {
    commit('SET_PROMO_CODE', promoCode);
};
const clearPromoCode = ({ commit }) => {
    commit('CLEAR_PROMO_CODE');
};
const saveCouponId = ({ commit }, couponID) => {
    commit('SET_COUPON_ID', couponID);
};
const clearCouponId = ({ commit }) => {
    commit('CLEAR_COUPON_ID');
};
const clearStates = ({ commit }) => {
    commit('CLEAR_COUPON_STATE');
};

const applyCoupon = async (context, payload) => {
    let couponModel = new CouponModel();
    return couponModel.applyCoupon(payload).then(res => {
        if (res.data && res.data.status === couponModel.STATUS_SUCCESS) {
            return res.data;
        }
        return res.data;
    }).catch(err => {
        return couponModel.getErrorResponse(err);
    });
}

export {
    checkEligibilityAndGetPriceAfterCouponPromo,
    checkEligibility,
    checkValidity,
    getNewPrice,
    getCouponId,
    savePromoCode,
    clearPromoCode,
    saveCouponId,
    clearCouponId,
    clearStates,
    applyCoupon
};
